// PEC-8280: un configCalendar con provider '' (persistido por versiones previas
// del modal de calendario por defecto) rompe la resolución del cliente de
// calendario en LexON/portal. Estas utilidades garantizan que nunca se
// construya ni se re-persista un configCalendar sin provider.

// Resuelve el provider del calendario seleccionado en el modal. El estado
// `selectedProvider` solo se rellena si el usuario disparó el change del
// desplegable; con la opción preseleccionada llega vacío y hay que derivarlo
// de la propia lista de calendarios.
export const resolveCalendarProvider = (selectedProvider, calendarList, selectedAccount) =>
  selectedProvider || calendarList?.find((cal) => cal.account === selectedAccount)?.provider || '';

// Devuelve un configCalendar con provider garantizado: si el almacenado es
// nulo o trae provider vacío, lo reconstruye buscando el provider de la
// cuenta a la que apunta; si tampoco se puede resolver, cae al provider y
// email de la sesión actual.
export const sanitizeConfigCalendar = (configCalendar, accounts, email, defaultProvider) => {
  if (configCalendar?.provider) {
    return configCalendar;
  }
  const calendarAccount = accounts?.find((acc) => acc.email === configCalendar?.account);
  if (calendarAccount?.provider) {
    return { provider: calendarAccount.provider, account: configCalendar.account };
  }
  return { provider: defaultProvider, account: email };
};
